export default __webpack_public_path__ + "static/media/JointsImg.f670095f.jpg";